import { IBooleanObject } from "../types/Base";

export const convertArrayToBooleanObject = (arr?: string[]) =>
  arr
    ? arr.reduce((acc: IBooleanObject, item) => ({ ...acc, [item]: true }), {})
    : {};
